import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/Store';
import type ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';

/**
 * Sets client-side readingPane position
 * @param clientReadingPanePosition Client-side reading pane position
 */
const setCurrentClientReadingPanePositionMutatorMutator: (
    clientReadingPanePosition: ReadingPanePosition | null
) => void = mutatorAction(
    'setCurrentClientReadingPanePosition',
    (clientReadingPanePosition: ReadingPanePosition | null): void => {
        getStore().clientReadingPanePosition = clientReadingPanePosition;
    }
);
export default setCurrentClientReadingPanePositionMutatorMutator;
